'use client';

import { useEffect } from 'react';

export default function RootScrollFixer() {
  useEffect(() => {
    // Only run on first load
    if (typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  }, []);

  return null;
}
